export class ProfileError extends Error {
    constructor({ message = 'Error fetching profile.', isEmailRequired = false, email = '' } = {}) {
        super(message);
        this.isEmailRequired = isEmailRequired;
        this.email = email;
        this.name = 'ProfileError';
    }
}
